import styled from '@emotion/styled';

export const HomePageStyle = styled.div`
   background-image: linear-gradient(${({ theme }) => theme.colors?.orange01} 50%, #f7f7f7 50%);
   height: 100vh;
   display: flex;
   align-items: center;
   justify-content: center;
   position:relative;
   &:after{
      content: "";
    background: url(https://rstheme.com/products/html/braintech/assets/images/bg/project-bg.png);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background-size: cover;
    z-index:1;
    -webkit-animation: slide 20s linear infinite;
   }
`;

export const HomePageContainer = styled.div`
   width: 900px;
   font-size: 1.5rem;
   line-height: 2.6rem;
   position:relative;
   z-index:9;
`;

export const TopHomePageCOntainer = styled.div`
   background-color: #fff;
   padding: 30px;
   height: 400px;
   display: grid;
   margin-bottom: 20px;
   text-align: center;
   border-radius: 30px;
   box-shadow: 0 0 5px 5px hsl(0deg 0% 40% / 8%);
`;

export const LeftHomePageContainer = styled.div`
   background-color: #fff;
   padding: 30px;
   width: 50%;
   text-align: center;
   border-radius: 30px;
   box-shadow: 0 0 5px 5px hsl(0deg 0% 40% / 8%);
   position: relative;
    z-index: 9;
`;

export const RightHomePageContainer = styled.div`
   background-color: #fff;
   margin-left: 20px;
   padding: 30px;
   width: 50%;
   border-radius: 30px;
   box-shadow: 0 0 5px 5px hsl(0deg 0% 40% / 8%);
   position: relative;
    z-index: 9;
    .contact_icon {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      box-shadow: 0 0 5px 5px hsl(0deg 0% 40% / 8%);
      border-radius: 50%;
  }
    h3{
       span{
          color:#ED7D32;
          font-size:20px;
       }
    }
`;
